import { configureStore } from '@reduxjs/toolkit';
import { expressApi } from './api/expressApi';
import authReducer from './authSlice';
import translationFlowReducer from './translationFlowSlice';
import accessReducer from './accessSlice';

// Import feature API slices to register their endpoints
import '@/features/upload/api/uploadApi';
import '@/features/analysis/api/analysisApi';
import '@/features/translate/api/translateApi';
import '@/features/user/api/userApi';
import '@/features/admin/api/adminApi';
import '@/features/translated-batches/api/translatedBatchesApi';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    translationFlow: translationFlowReducer,
    access: accessReducer,
    [expressApi.reducerPath]: expressApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(expressApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
